export default "__VITE_ASSET__D9m6Vrar__"